/* Kaori UI: shared behaviour for the custom Kaori sections. */
(function () {
  if (window.KaoriUI) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Reveal elements as they scroll into view
  var io = null;
  function reveal(scope) {
    var els = (scope || document).querySelectorAll('.k-rv:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (n) { n.classList.add('is-in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          en.target.classList.add('is-in');
          io.unobserve(en.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    }
    els.forEach(function (n) { io.observe(n); });
  }

  // Fallback for browsers that skip observer callbacks: check positions on scroll
  var pending = false;
  function sweep() {
    pending = false;
    var limit = window.innerHeight * 0.95;
    document.querySelectorAll('.k-rv:not(.is-in)').forEach(function (n) {
      var r = n.getBoundingClientRect();
      if (r.top < limit && r.bottom > 0 && !n.closest('[hidden]')) n.classList.add('is-in');
    });
  }
  function queueSweep() { if (!pending) { pending = true; requestAnimationFrame(sweep); } }
  window.addEventListener('scroll', queueSweep, { passive: true });
  window.addEventListener('resize', queueSweep);
  window.addEventListener('load', queueSweep);

  function esc(s) { return String(s || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  // Button feedback: plus turns into a tick for a moment
  function added(btn) {
    if (!btn) return;
    var label = btn.querySelector('.kc-btn__label');
    var old = label ? label.textContent : null;
    btn.classList.add('is-added');
    if (label) label.textContent = 'Added';
    clearTimeout(btn._kTimer);
    btn._kTimer = setTimeout(function () { btn.classList.remove('is-added'); if (label) label.textContent = old; }, 1700);
  }

  // Keep the theme's cart drawer and basket count in step after our own cart calls
  function refreshDrawer(sections) {
    var html = sections && sections['ajax-cart-drawer'];
    var body = document.querySelector('[data-cart-drwaer-body]');
    if (!html || !body) return;
    var doc = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
    if (!doc) return;
    var sc = body.querySelector('.cart-drawer-content-body'), top = sc ? sc.scrollTop : 0;
    body.innerHTML = doc.innerHTML;
    sc = body.querySelector('.cart-drawer-content-body');
    if (sc && top) sc.scrollTop = top;
    var wrap = doc.querySelector('[data-cart-wrapper]');
    var count = wrap ? parseInt(wrap.getAttribute('data-item-count'), 10) : null;
    var drawer = document.querySelector('#ajax-cart-drawer');
    var call = function (fn, arg) { try { if (typeof window[fn] === 'function') window[fn](arg); } catch (e) {} };
    if (count > 0) call('getQuantityElement', body);
    if (count !== null) call('cartCountUpdate', count);
    call('cartNoteUpdate');
    call('getCartItemRemoveElements', drawer);
    call('cartGiftWrapElement', drawer);
    call('cartTermhandlerClick');
    call('cartTermsHandler');
    document.dispatchEvent(new CustomEvent('kaori:drawer-refreshed'));
  }

  // A small copy of the product photo flies into the basket icon
  function flyToCart(img) {
    var icon = document.querySelector('.cart.header-icons-link');
    if (reduce || !img || !icon || !img.animate) return;
    var a = img.getBoundingClientRect(), b = icon.getBoundingClientRect();
    if (!a.width || !b.width || b.top < -50) return;
    var g = document.createElement('div');
    g.className = 'k-fly';
    g.style.cssText = 'left:' + a.left + 'px;top:' + a.top + 'px;width:' + a.width + 'px;height:' + a.height + 'px;';
    g.innerHTML = '<img src="' + esc(img.currentSrc || img.src) + '" alt="">';
    document.body.appendChild(g);
    var s = 34 / a.width;
    var dx = b.left + b.width / 2 - 17 - a.left, dy = b.top + b.height / 2 - 17 - a.top;
    g.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1, borderRadius: '16px' },
      { transform: 'translate(' + dx * 0.5 + 'px,' + (dy * 0.5 - 90) + 'px) scale(' + (s + 0.3) + ')', opacity: 1, offset: 0.55 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(' + s + ')', opacity: 0.2, borderRadius: '50%' }
    ], { duration: 750, easing: 'cubic-bezier(.2,.7,.2,1)' }).onfinish = function () {
      g.remove();
      icon.classList.remove('k-bump'); void icon.offsetWidth; icon.classList.add('k-bump');
    };
  }

  // Quick add from any card. Opens the theme's cart drawer so the deal progress in it is seen.
  function quickAdd(btn) {
    var id = btn.getAttribute('data-k-add');
    if (!id || btn.disabled || btn.classList.contains('is-busy')) return;
    var card = btn.closest('.kc-card, .k-card');
    var img = card && (card.querySelector('.kc-media__slide.is-current img') || card.querySelector('img'));
    var err = card && card.querySelector('[data-form-error]');
    if (err) { err.textContent = ''; err.hidden = true; }
    btn.classList.add('is-busy');
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }], sections: 'ajax-cart-drawer' })
    }).then(function (r) { return r.json(); }).then(function (res) {
      btn.classList.remove('is-busy');
      if (res && res.status) throw new Error(res.description || res.message || 'Could not add this item.');
      added(btn);
      flyToCart(img);
      var hasDrawer = !!document.querySelector('[data-cart-drwaer-body]');
      refreshDrawer(res.sections);
      document.dispatchEvent(new CustomEvent('kaori:cart-changed'));
      // The basket page updates itself (kaori:cart-changed); anywhere else without a drawer, go to the basket
      if (!hasDrawer) { if (!document.getElementById('kcart')) window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart'; return; }
      if (!btn.closest('#ajax-cart-drawer')) toast(card, img);
      if (btn.hasAttribute('data-k-open-cart')) {
        setTimeout(function () { var icon = document.querySelector('.cart.header-icons-link'); if (icon) icon.click(); }, reduce ? 0 : 650);
      }
    }).catch(function (e) {
      btn.classList.remove('is-busy');
      if (err) { err.textContent = e.message; err.hidden = false; }
    });
  }

  // Toast after adding: shows progress toward the 3-for deal
  var toastEl = null, toastTimer = null;
  function toast(card, img) {
    var deal = window.KaoriDeal || { unit: 1000, qty: 3, price: 2000 };
    var name = card ? ((card.querySelector('.kc-card__name, .k-card__name, .kp__title') || {}).textContent || '').trim() : '';
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var n = 0;
        var other = 0;
        (cart.items || []).forEach(function (it) { if (it.original_price === deal.unit && it.product_has_only_default_variant) n += it.quantity; else other += it.original_line_price || 0; });
        // Our own total, so the deal discount is always counted before free delivery
        var rep = !!window.KaoriDealRepeat;
        var saveFor = function (k) { var sv = deal.unit * deal.qty - deal.price; return rep ? Math.floor(k / deal.qty) * sv : (k >= deal.qty ? sv : 0); };
        var effTotal = n * deal.unit - saveFor(n) + other;
        var left = deal.qty - n;
        var cur = (cart.currency === 'GBP' || !cart.currency) ? '£' : '';
        var m = function (p) { var v = p / 100; return cur + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2)); };
        var save = deal.unit * deal.qty - deal.price;
        var line;
        if (n === 0) line = 'In your basket';
        else if (left > 1) line = 'Add <b>' + left + ' more</b> and get ' + deal.qty + ' for ' + m(deal.price);
        else if (left === 1) line = 'Add <b>1 more</b> and save ' + m(save);
        else if ((deal.freeShip || 3000) <= effTotal && rep && n % deal.qty) {
          var rem = deal.qty - n % deal.qty, nextT = (n + rem) * deal.unit - saveFor(n + rem), extra = nextT - (n * deal.unit - saveFor(n));
          line = extra <= 0 ? '<b>Add one more air freshener for free</b>' : '<b>Free UK delivery</b> on your order';
        }
        else if ((deal.freeShip || 3000) > effTotal) { var shipN = Math.max(1, Math.ceil(((deal.freeShip || 3000) - effTotal) / deal.unit)); line = '<b>Bundle created.</b> Add ' + (shipN === 1 ? 'one more air freshener' : shipN + ' more air fresheners') + ' to unlock FREE UK delivery'; }
        else line = '<b>Free UK delivery</b> on your order';
        if (!toastEl) {
          toastEl = document.createElement('div');
          toastEl.className = 'k-toast';
          toastEl.setAttribute('role', 'status');
          document.body.appendChild(toastEl);
          toastEl.addEventListener('click', function (e) {
            if (!e.target.closest('[data-k-toast-open]')) return;
            toastEl.classList.remove('is-on');
            var icon = document.querySelector('.cart.header-icons-link');
            if (icon) icon.click(); else window.location.href = '/cart';
          });
        }
        toastEl.innerHTML = (img ? '<img src="' + esc(img.currentSrc || img.src) + '" alt="">' : '') +
          '<span class="k-toast__text"><strong>' + esc(name || 'Added') + (name ? ' added' : '') + '</strong><span>' + line + '</span></span>' +
          '<button type="button" class="k-toast__btn" data-k-toast-open>View basket</button>';
        requestAnimationFrame(function () { toastEl.classList.add('is-on'); });
        clearTimeout(toastTimer);
        toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 5200);
      }).catch(function () {});
  }

  // Card photo galleries: dots, arrows, and the current slide
  function initGallery(g) {
    if (g.dataset.kReady) return;
    g.dataset.kReady = '1';
    var track = g.querySelector('[data-kc-track]');
    var slides = track ? track.children : [];
    var dots = g.querySelectorAll('.kc-media__dots i');
    var prev = g.querySelector('[data-kc-prev]'), next = g.querySelector('[data-kc-next]');
    if (!track || slides.length < 2) { if (slides[0]) slides[0].classList.add('is-current'); return; }
    var idx = 0;
    function update() {
      var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
      if (i === idx && slides[i].classList.contains('is-current')) return;
      idx = Math.max(0, Math.min(i, slides.length - 1));
      for (var k = 0; k < slides.length; k++) slides[k].classList.toggle('is-current', k === idx);
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === idx); });
      if (prev) prev.disabled = idx === 0;
      if (next) next.disabled = idx === slides.length - 1;
    }
    function go(d) { track.scrollTo({ left: (idx + d) * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' }); }
    var t = false;
    track.addEventListener('scroll', function () { if (!t) { t = true; requestAnimationFrame(function () { t = false; update(); }); } }, { passive: true });
    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); go(-1); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); go(1); });
    slides[0].classList.add('is-current');
    if (prev) prev.disabled = true;
  }

  // Notify me (Klaviyo back in stock)
  function klaviyoKey(el) {
    var host = el.closest('[data-klaviyo]');
    return (host && host.getAttribute('data-klaviyo')) || window.KaoriKlaviyo || 'VPR85R';
  }
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-kc-notify-open]');
    if (!open) return;
    var card = open.closest('.kc-card, .kp');
    var form = card && card.querySelector('[data-kc-notify]');
    if (!form) return;
    card.classList.add('is-notifying');
    open.setAttribute('aria-expanded', 'true');
    form.hidden = false;
    var input = form.querySelector('input');
    if (input) input.focus();
  });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-kc-notify]');
    if (!form) return;
    e.preventDefault();
    var input = form.querySelector('input[type="email"]');
    var msg = form.querySelector('[data-kc-notify-msg]');
    var btn = form.querySelector('button[type="submit"]');
    var email = (input.value || '').trim();
    msg.classList.remove('is-error');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      msg.textContent = 'Please enter a valid email.';
      msg.classList.add('is-error');
      input.focus();
      return;
    }
    btn.disabled = true;
    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(klaviyoKey(form)), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', Accept: 'application/vnd.api+json', revision: '2024-10-15' },
      body: JSON.stringify({ data: {
        type: 'back-in-stock-subscription',
        attributes: { profile: { data: { type: 'profile', attributes: { email: email } } }, channels: ['EMAIL'] },
        relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + form.getAttribute('data-variant') } } }
      } })
    }).then(function (r) {
      if (!r.ok) throw new Error('bad');
      form.classList.add('is-done');
      msg.textContent = "You're on the list. We'll email you when it's back.";
    }).catch(function () {
      btn.disabled = false;
      msg.textContent = 'Something went wrong. Please try again.';
      msg.classList.add('is-error');
    });
  });

  // Tabs
  function initTabs(root) {
    var tabs = root.querySelectorAll('[data-k-tab]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('aria-controls');
        tabs.forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); t.tabIndex = t === tab ? 0 : -1; });
        root.querySelectorAll('[data-k-panel]').forEach(function (p) {
          var on = p.id === target;
          p.hidden = !on;
          if (on && !reduce) {
            p.classList.remove('is-entering');
            void p.offsetWidth;
            p.classList.add('is-entering');
            reveal(p);
          }
        });
      });
      tab.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var list = Array.prototype.slice.call(tabs);
        var i = list.indexOf(tab) + (e.key === 'ArrowRight' ? 1 : -1);
        var next = list[(i + list.length) % list.length];
        next.focus();
        next.click();
      });
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-k-add]');
    if (btn) { e.preventDefault(); quickAdd(btn); }
  });

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-kc-gallery]').forEach(initGallery);
    scope.querySelectorAll('[data-k-tabs]').forEach(function (r) {
      if (r.dataset.kReady) return;
      r.dataset.kReady = '1';
      initTabs(r);
    });
    reveal(scope);
    queueSweep();
  }

  // The brand word: wrap every "Kaori" in the page so it shows in the logo font
  var SKIP = /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA|INPUT|SELECT|OPTION|SVG|TITLE|CODE|PRE)$/;
  function brandify(root) {
    if (!root || !document.fonts) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!n.nodeValue || !/kaori/i.test(n.nodeValue)) return NodeFilter.FILTER_REJECT;
        for (var p = n.parentNode; p && p !== document.body; p = p.parentNode) {
          if (p.nodeType === 1 && (SKIP.test(p.nodeName.toUpperCase()) || p.classList.contains('k-brand') || p.classList.contains('kcl') || p.isContentEditable || p.hasAttribute('data-no-brand'))) return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (n) {
      // Only a standalone "Kaori": the whole label, or the first or last word of a heading or label.
      // In the middle of a sentence it stays in the normal font.
      var block = n.parentNode;
      while (block && block !== document.body && /^inline/.test(getComputedStyle(block).display)) block = block.parentNode;
      if (!block) return;
      var full = block.textContent;
      var lead = full.length - full.replace(/^\s+/, '').length;
      var core = full.replace(/[\s.!…,:;"'’”)]+$/, '');
      // Headings and short labels only; sentences of normal text (and customer reviews) stay as they are
      var isHeading = /^H[1-6]$/.test(block.nodeName);
      if (!isHeading && (core.trim().split(/\s+/).length > 8 || block.closest('blockquote'))) return;
      var range = document.createRange();
      range.setStart(block, 0);
      try { range.setEnd(n, 0); } catch (e) { return; }
      var offset = range.toString().length;
      var text = n.nodeValue, re = /kaori/ig, m, cuts = [];
      while ((m = re.exec(text))) {
        var at = offset + m.index;
        if (at === lead || at + 5 === core.length) cuts.push(m.index);
      }
      if (!cuts.length) return;
      var frag = document.createDocumentFragment(), pos = 0;
      cuts.forEach(function (i) {
        if (i > pos) frag.appendChild(document.createTextNode(text.slice(pos, i)));
        var sp = document.createElement('span'); sp.className = 'k-brand'; sp.textContent = text.slice(i, i + 5); frag.appendChild(sp);
        pos = i + 5;
      });
      if (pos < text.length) frag.appendChild(document.createTextNode(text.slice(pos)));
      n.parentNode.replaceChild(frag, n);
    });
  }
  function startBrand() {
    // Only switch the word over once the logo font has actually loaded
    try { document.fonts.load('20px "Kaori Graffiti"').then(function (f) { if (f && f.length) document.documentElement.classList.add('k-has-brand'); }); } catch (e) {}
    brandify(document.body);
    if (!('MutationObserver' in window)) return;
    var pending = [], queued = false;
    new MutationObserver(function (muts) {
      muts.forEach(function (m) { m.addedNodes.forEach(function (n) { pending.push(n); }); });
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        var list = pending; pending = [];
        list.forEach(function (n) {
          if (!n.isConnected) return;
          if (n.nodeType === 1) brandify(n); else if (n.nodeType === 3 && n.parentNode) brandify(n.parentNode);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startBrand); else startBrand();

  window.KaoriUI = { init: init, reveal: reveal, added: added, refreshDrawer: refreshDrawer, flyToCart: flyToCart, initGallery: initGallery };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* ---------- Celebrations: 3 for £20 unlocked, free delivery unlocked ----------
   Watches every basket change (any add/change/remove on the site), works out the
   deal from the basket, and celebrates when a new set or free delivery is reached. */
(function () {
  if (window.KaoriCelebrate) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var KEY = 'kaori_milestones';
  var deal = function () { return window.KaoriDeal || { unit: 1000, qty: 3, price: 2000, freeShip: 3000 }; };
  function money(p) { var v = p / 100; return '£' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2)); }
  function getState() { try { return JSON.parse(sessionStorage.getItem(KEY)) || null; } catch (e) { return null; } }
  function setState(s) { try { sessionStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {} }

  function measure(cart) {
    var d = deal(), n = 0, other = 0;
    (cart.items || []).forEach(function (it) {
      if (it.original_price === d.unit && it.product_has_only_default_variant) n += it.quantity;
      else other += it.original_line_price || 0;
    });
    var save = d.unit * d.qty - d.price;
    var sets = Math.floor(n / d.qty);
    if (!window.KaoriDealRepeat && sets > 1) sets = 1;
    var total = n * d.unit - sets * save + other;
    return { n: n, sets: sets, saving: sets * save, total: total, free: (cart.item_count || 0) > 0 && total >= (d.freeShip || 3000) };
  }

  // Notice: a slim, quiet card under the header (no confetti, no pop-up in the middle of the screen)
  var layer = null, hideT = null, DUR = 3600;
  function ensureLayer() {
    if (layer) return layer;
    layer = document.createElement('div');
    layer.className = 'k-cele';
    layer.setAttribute('role', 'status');
    layer.setAttribute('aria-live', 'polite');
    layer.innerHTML = '<div class="k-cele__card"></div>';
    document.body.appendChild(layer);
    layer.addEventListener('click', hide);
    return layer;
  }
  function hide() { if (!layer) return; layer.classList.remove('is-on'); clearTimeout(hideT); }
  var TICK = '<svg class="k-cele__icon" width="34" height="34" viewBox="0 0 34 34" aria-hidden="true"><circle cx="17" cy="17" r="16" fill="none" stroke="currentColor" stroke-opacity=".18"/><path class="k-cele__tick" d="M11 17.5l4 4 8-9" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var BOX = '<svg class="k-cele__icon" width="34" height="34" viewBox="0 0 34 34" aria-hidden="true"><circle cx="17" cy="17" r="16" fill="none" stroke="currentColor" stroke-opacity=".18"/><path class="k-cele__tick" d="M10.5 13.5 17 10l6.5 3.5v7L17 24l-6.5-3.5zM10.5 13.5 17 17l6.5-3.5M17 17v7" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/></svg>';

  function show(kind, m) {
    var el = ensureLayer(), card = el.querySelector('.k-cele__card'), d = deal();
    if (kind === 'deal') {
      var sets = 1, qty = d.qty, price = d.price;
      card.innerHTML = TICK + '<span class="k-cele__text"><span class="k-cele__tag">Offer applied</span><strong class="k-cele__big">' + qty + ' for ' + money(price) + '</strong><span class="k-cele__sub">You\'re saving ' + money(d.unit * d.qty - d.price) + (m.free ? ', with free UK delivery.' : '. One more for free UK delivery.') + '</span></span><i class="k-cele__time" aria-hidden="true"></i>';
    } else {
      card.innerHTML = BOX + '<span class="k-cele__text"><span class="k-cele__tag">Delivery</span><strong class="k-cele__big">Free UK delivery</strong><span class="k-cele__sub">Your order now ships free.</span></span><i class="k-cele__time" aria-hidden="true"></i>';
    }
    // One message at a time: this replaces the "added" notice
    var t = document.querySelector('.k-toast.is-on'); if (t) t.classList.remove('is-on');
    el.classList.remove('is-on', 'is-deal', 'is-free'); void el.offsetWidth;
    el.classList.add('is-on', kind === 'deal' ? 'is-deal' : 'is-free');
    clearTimeout(hideT);
    hideT = setTimeout(hide, DUR);
  }

  // Decide what to celebrate (one at a time, deal first)
  var queue = [];
  function run() {
    if (!queue.length) return;
    var next = queue.shift();
    show(next.kind, next.m);
    if (queue.length) setTimeout(run, DUR + 400);
  }
  function compare(m, prev) {
    if (!prev) return;
    if (m.sets >= 1 && prev.sets < 1) queue.push({ kind: 'deal', m: m });
    if (m.free && !prev.free && m.sets >= 1) queue.push({ kind: 'free', m: m });
    if (queue.length) run();
  }
  function check(isLoad) {
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var m = measure(cart), prev = getState();
        if (!isLoad || (prev && prev.pending)) compare(m, prev && { sets: prev.sets, free: prev.free });
        setState({ sets: m.sets, free: m.free });
      }).catch(function () {});
  }

  // Keep the whole side cart (items, numbers and deal panel) in step with the real basket,
  // even when it changed somewhere the theme doesn't watch (another tab, an app, the Back button)
  var dealT = null;
  function refreshDeal() {
    clearTimeout(dealT);
    dealT = setTimeout(function () {
      var body = document.querySelector('[data-cart-drwaer-body] .cart-drawer-content-body');
      if (!body) return;
      orig.call(window, (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + '?section_id=ajax-cart-drawer')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          if (window.KaoriUI && window.KaoriUI.refreshDrawer) { window.KaoriUI.refreshDrawer({ 'ajax-cart-drawer': html }); return; }
          var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.cart-drawer-content-body > .kdl');
          var body2 = document.querySelector('[data-cart-drwaer-body] .cart-drawer-content-body');
          if (!body2) return;
          var cur = body2.querySelector(':scope > .kdl');
          if (fresh && cur) cur.replaceWith(fresh);
          else if (fresh) body2.appendChild(fresh);
          else if (cur) cur.remove();
        }).catch(function () {});
    }, 350);
  }

  window.KaoriRefreshCart = refreshDeal;

  // Watch every basket change made through fetch (theme, Kaori sections, apps)
  var orig = window.fetch;
  if (window.fetch && !window.fetch.__kaori) {
    var wrapped = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = orig.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
        p.then(function () { setTimeout(function () { check(false); refreshDeal(); document.dispatchEvent(new CustomEvent('kaori:cart-mutated')); }, 250); }).catch(function () {});
      }
      return p;
    };
    wrapped.__kaori = true;
    window.fetch = wrapped;
  }
  // Pages that reload after a change (the cart page) celebrate on arrival
  window.addEventListener('beforeunload', function () { var s = getState(); if (s) { s.pending = true; setState(s); } });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { check(true); });
  else check(true);
  // Coming back to a page (Back button, another tab): everything re-reads the real basket
  window.addEventListener('pageshow', function (e) { if (e.persisted) { refreshDeal(); document.dispatchEvent(new CustomEvent('kaori:cart-mutated')); } });
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') { refreshDeal(); document.dispatchEvent(new CustomEvent('kaori:cart-mutated')); } });

  // The bundle page celebrates as picks are chosen (before they reach the basket)
  window.KaoriCelebrate = function (kind, info) {
    var d = deal(), sets = info && info.sets || 1;
    var m = { sets: sets, saving: sets * (d.unit * d.qty - d.price), free: !!(info && info.free) };
    queue.push({ kind: kind, m: m }); run();
    var s = getState() || { sets: 0, free: false };
    setState({ sets: Math.max(s.sets, kind === 'deal' ? sets : s.sets), free: s.free || kind === 'free' });
  };
})();

/* Lock the page behind any open side drawer (cart). Fallback for browsers without :has(). */
(function () {
  function sync() {
    var open = !!document.querySelector('.side-drawer.sidebar-visible');
    document.documentElement.classList.toggle('k-drawer-lock', open);
  }
  function watch() {
    document.querySelectorAll('.side-drawer').forEach(function (d) {
      if (d.dataset.kLockWatch) return;
      d.dataset.kLockWatch = '1';
      new MutationObserver(sync).observe(d, { attributes: true, attributeFilter: ['class', 'style'] });
    });
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
})();

/* Side cart + / - / Remove: our own handlers.
   Attached once for the whole page, one request at a time, and each item is changed by its
   exact basket line key (not its position), so split discount lines can never be mixed up. */
(function () {
  if (window.__kaoriQty) return;
  window.__kaoriQty = true;
  var busy = false;
  var base = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
  // A shown line can stand for several real basket lines (data-lines="key:qty|key:qty"), because
  // the 3 for £20 discount splits one scent. Changes go to those exact lines by key.
  function linesOf(el) {
    return ((el && el.getAttribute('data-lines')) || '').split('|').filter(Boolean).map(function (x) {
      var i = x.lastIndexOf(':');
      return { key: x.slice(0, i), qty: parseInt(x.slice(i + 1), 10) || 0 };
    });
  }
  function setTotal(el, target, row) {
    if (busy || !el) return;
    var ls = linesOf(el);
    if (!ls.length) { var k = el.getAttribute('data-key'); if (k) ls = [{ key: k, qty: parseInt((row && row.querySelector('[data-kq-input]') || {}).value, 10) || 0 }]; }
    if (!ls.length) return;
    var cur = ls.reduce(function (a, l) { return a + l.qty; }, 0);
    target = Math.max(0, target);
    if (target === cur) return;
    var updates = {};
    if (target > cur) {
      var last = ls[ls.length - 1];
      updates[last.key] = last.qty + (target - cur);
    } else {
      var rem = cur - target;
      for (var i = ls.length - 1; i >= 0 && rem > 0; i--) {
        var take = Math.min(ls[i].qty, rem);
        updates[ls[i].key] = ls[i].qty - take;
        rem -= take;
      }
    }
    busy = true;
    var item = row && row.closest('[data-cart-item]');
    if (item) item.classList.add('disabled');
    fetch(base + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates, sections: 'ajax-cart-drawer' })
    }).then(function (r) { return r.json(); }).then(function (res) {
      busy = false;
      if (window.KaoriUI && res && res.sections) window.KaoriUI.refreshDrawer(res.sections);
      else if (window.KaoriRefreshCart) window.KaoriRefreshCart();
      document.dispatchEvent(new CustomEvent('kaori:cart-changed'));
    }).catch(function () { busy = false; if (item) item.classList.remove('disabled'); if (window.KaoriRefreshCart) window.KaoriRefreshCart(); });
  }
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-kq-step]');
    if (step) {
      e.preventDefault(); e.stopPropagation();
      var wrap = step.closest('[data-kq-wrap]'), input = wrap && wrap.querySelector('[data-kq-input]');
      if (!input) return;
      // Quick taps add up: show the new number straight away, send once the tapping stops
      input.value = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-kq-step'), 10));
      clearTimeout(wrap._kT);
      wrap._kT = setTimeout(function commit() { if (busy) { wrap._kT = setTimeout(commit, 150); return; } setTotal(wrap, parseInt(input.value, 10) || 0, wrap); }, 350);
      return;
    }
    var rm = e.target.closest('[data-kq-remove]');
    if (rm) { e.preventDefault(); e.stopPropagation(); setTotal(rm, 0, rm); }
  }, true);
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-kq-input]');
    if (input) setTotal(input, parseInt(input.value, 10) || 0, input);
  }, true);
})();
